import { render } from "./Hallgato.vue?vue&type=template&id=51c450d8"
import script from "./Hallgato.vue?vue&type=script&lang=js"
export * from "./Hallgato.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__